<mat-card appearance="outlined" class="mat-elevation-z8">
    <mat-tab-group (selectedTabChange)="onTabChange($event)" animationDuration="0ms">

        <!-- Таб 1 -->
        <mat-tab>
            <ng-template mat-tab-label class="mat-mdc-tab-label-container">
                <cqes-icon icon="done"></cqes-icon>
                {{ 'certificates.titlePage' | translate }}
            </ng-template>
            <div class="p-4">
                <cloud-business-hardware-certificates-reports></cloud-business-hardware-certificates-reports>
            </div>
        </mat-tab>

        <!-- Таб 2 -->
        <mat-tab>
            <ng-template mat-tab-label class="mat-mdc-tab-label-container">
                <cqes-icon icon="done"></cqes-icon>
                {{ 'businessTexts.managementRequests' | translate }}
            </ng-template>
            <div class="p-4" *ngIf="hasSecondTabBeenSelected">
                <cloud-business-management-requests-report-qes></cloud-business-management-requests-report-qes>
            </div>
        </mat-tab>

    </mat-tab-group>
</mat-card>